import {  ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';

@Component({
    selector: 'clever-offerpackdetailheader',
    templateUrl: './offerpackdetailheader.component.html',
    styleUrls: ['./offerpackdetailheader.component.scss'],
    standalone: false
})
export class OfferpackdetailheaderComponent implements OnInit, OnChanges {
    @Output() sendStep: EventEmitter<number> = new EventEmitter();
    @Input() step: number = 0;
    constructor (
        protected cdr: ChangeDetectorRef
    ) { }

    ngOnInit (): void {
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['step']) {
            this.cdr.markForCheck();
        }
    }

    sendLastStep (ss) {
        if (this.step !== ss) {
            this.sendStep.emit(ss);
        }
    }
}
